import React, { useEffect, useState } from "react";
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../../Dialog/Dialog';
import {
    Button,
    Drawer,
    Grid,
    InputAdornment,
    ListItem,
    List,
    makeStyles,
    TextField,
    FormHelperText
} from '@material-ui/core';
import * as logger from '../../../../logger';
import { connect } from 'react-redux';
import * as constants from "../../../../store/constants";
import { calculateCashBack } from "../../../../store/actions/vehicleActionCreator";
import { numberFormat, numberFormatComma, removeNumberCommas, checkNumberOnly } from "../../../../utils/utils";
import classNames from 'classnames';
import { updateChatView } from "../../../../store/actions/userActionCreators";
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const useStyles = makeStyles((theme) => ({

    divTitle: {
        fontSize: '12px',
        fontWeight: 500,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    transactionDetailsDrawer: {
        width: 475,
        maxWidth: 475,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px',
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px',
        }
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 24,
        backgroundColor: '#f6f6f8'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    divAlignV1: {
        display: 'flex',
    },
    rechargeAmount: {
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'left',
        color: '#008556',
        marginTop: 4
    },
    rechargeAmountBlack: {
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'left',
        color: 'black',
        marginTop: 4
    },
    cashbackEarned: {
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'right',
        color: '#2c5de5',
        marginTop: 4
    },
    divDialogTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#0b1323'
    },
    nextLimitNoteText: {
        fontSize: '14px',
        color: 'rgba(11, 19, 35, 0.75)',
        textAlign: 'center',
        width: '100%',
        marginTop: 24
    },
    divRechargeContainer: {
        backgroundColor: 'white',
        padding: '16px 12px 12px 24px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc'
    },
    listItemContainer: {
        backgroundColor: '#f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        fontWeight: 'bold'
    },
    listItemContainerV1: {
        width: '100%',
        borderBottom: '1px solid #f0f0f0',
        fontSize: '12px !important',
        fontWeight: 300
    },
    width100: {
        width: '100%'
    },
    listConatiner: {
        backgroundColor: 'white',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc'
    },
    mt32: {
        marginTop: 32
    },
    fwBold: {
        fontWeight: 'bold'
    },
    divNoteContainer: {
        marginTop: '8px',
        backgroundColor: 'white',
        border: '1px solid #dcdcdc',
        display: 'flex',
        padding: '12px 22px 12px 22px',
        borderRadius: '8px'
    },
    calculateButton: {
        padding: '11px 20px',
        borderRadius: '4px',
        backgroundColor: '#0033cc',
        textTransform: 'none !important',
        color: 'white',
        height: '46px',
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#0033cc'
        }
    },
    mt8: {
        marginTop: 8
    },
    divAmountContainer: {
        padding: '12px 16px',
        borderRadius: '8px',
        backgroundColor: '#f1f3f6',
        marginTop: '12px',
        fontSize: '12px'
    },
    calculatorContainer: {
        backgroundColor: 'white',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        padding: '12px 16px'
    },
    titleV1: {
        fontWeight: 'bold'
    },
    textV1: {
        fontSize: 12,
        marginTop: 12
    },
    textFieldV1: {
        width: '100%',
        "& .MuiOutlinedInput-input": {
            paddingTop: '14px !important',
            paddingBottom: '14px !important'
        }
    },
    mr8: {
        marginRight: 8
    },
    disableCalculateButton: {
        padding: '11px 20px',
        borderRadius: '4px',
        backgroundColor: '#dadada',
        textTransform: 'none !important',
        color: '#5e636c',
        height: '46px',
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#dadada'
        }
    },
    cashbackAmount: {
        fontSize: 16,
        fontWeight: 'bold',
        marginLeft: '12px'
    },
    bgColorV1: {
        backgroundColor: '#d6fedb'
    },
    divAlignV2: {
        display: 'flex',
        alignItems: 'center'
    },
    youText: {
        color: "#008556",
        fontWeight: 300,
        display: 'flex',
        alignItems: 'center'
    },
    arrowRight: {
        color: '#008556',
        fontSize: '22px'
    },
    rechargeButton: {
        backgroundColor: '#09101e',
        padding: '6px 18px',
        borderRadius: '4px',
        color: 'white',
        textTransform: 'none !important',
        marginLeft: '16px !important',
        fontWeight: '500',
        boxShadow: 'none !important',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    closeButton: {
        padding: '7px 19.5px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05)',
        border: 'solid 1px #d8dce6',
        backgroundImage: 'linear-gradient(to top, #f6f7f9, #fff)',
        textTransform: 'none !important',
        fontWeight: 500
    }

}))

const CashbackStepperDialog = ({ open, onClose, dispatchGetCashbackStepper, dispatchCalculateCashback, dispatchChatView, vehicle }) => {

    const [sideBarOpen, setSideBarOpen] = useState(open);
    const [cashbackStepperInfo, setCashbackStepperInfo] = useState({});
    const [fuelExpenseValue, setFuelExpenseValue] = useState(null);
    const [fuelExpenseError, setFuelExpenseError] = useState(false);
    const [cashbackCalValue, setCashbackCalValue] = useState({});
    const [confirmDisabled, setConfirmDisabled] = useState(true);
    const [rechargeSideBarOpen, setRechargeSideBarOpen] = useState(false);

    const classes = useStyles();

    const d = new Date();
    let month = d.getMonth();
    let year = d.getFullYear();
    const currentMonth = constants.MONTHS[month]

    useEffect(() => {

        dispatchChatView(false);

    }, []);

    useEffect(() => {

        if (vehicle && vehicle.dieselCardStepperDetails) {
            setCashbackStepperInfo(vehicle.dieselCardStepperDetails)
        }

    }, [vehicle.dieselCardStepperDetails])

    const handleClose = () => {
        setSideBarOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const handleFuelExpenseChange = (data) => {

        const formattedData = removeNumberCommas(data)
        setCashbackCalValue({});

        if (data && data != '') {
            if (checkNumberOnly(formattedData)) {
                setFuelExpenseValue(data)
                setConfirmDisabled(false)
            }
        } else {
            setConfirmDisabled(true);
            setFuelExpenseValue(null)
        }
    }

    const handleCalculateClick = () => {

        if (fuelExpenseValue && !fuelExpenseError) {

            dispatchCalculateCashback(removeNumberCommas(fuelExpenseValue),
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        setCashbackCalValue(data.response);
                        logger.log("Cashback Stepper Dweb", "Calculate cashback successful");
                    }
                },
                () => {
                    logger.log("Cashback Stepper Dweb", "Calculate cashback failed");
                }
            )

        } else {
            setConfirmDisabled(true);
        }

    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={sideBarOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >

                <SideBarDialogTitle id={"right-sidebar-for-recharge-diesel-card"} siderBarType={'CashbackStepper'} onClose={handleClose}>
                    <div className={classes.divDialogTitle}>
                        {currentMonth} Diesel Cashback
                    </div>
                </SideBarDialogTitle>

                <SideBarDialogContent className={classes.sideBarDialogContentV1}>
                    <div className={classes.divRechargeContainer}>
                        <div className={classes.divAlign}>
                            <div>
                                <div className={classes.divTitle}>{currentMonth} Recharges</div>
                                <div className={cashbackStepperInfo && cashbackStepperInfo.rechargeAmount == 0 ? classes.rechargeAmountBlack : classes.rechargeAmount}>{numberFormat(cashbackStepperInfo && cashbackStepperInfo.rechargeAmount ? cashbackStepperInfo.rechargeAmount : 0)}</div>
                            </div>

                            <div>
                                <div className={classes.divTitle}>Cashback Earned</div>
                                <div className={classes.cashbackEarned}>{numberFormat(cashbackStepperInfo && cashbackStepperInfo.cashbackAmount ? cashbackStepperInfo.cashbackAmount : 0)}&nbsp;({cashbackStepperInfo && cashbackStepperInfo.cashbackPercentage ? cashbackStepperInfo.cashbackPercentage : ""})</div>
                            </div>
                        </div>
                        <div className={classes.nextLimitNoteText}>
                            {cashbackStepperInfo && cashbackStepperInfo.nextLimitNote ? cashbackStepperInfo.nextLimitNote : ""}
                        </div>
                    </div>

                    <div className={classes.mt32}>
                        <List className={classes.listConatiner}>
                            <ListItem className={classes.listItemContainer}>
                                <div>Diesel recharge slab</div>
                                <div>Rewards</div>
                            </ListItem>
                            {cashbackStepperInfo && cashbackStepperInfo.cashbackStepper && cashbackStepperInfo.cashbackStepper.map((stepperDetails) => (
                                <ListItem className={stepperDetails.status && stepperDetails.status.toLowerCase() == "in_range" ? classNames(classes.bgColorV1, classes.listItemContainerV1) : classes.listItemContainerV1}>
                                    <div className={classNames(classes.divAlign, classes.width100)}>
                                        <div>{stepperDetails && stepperDetails.note ? stepperDetails.note : ""}</div>
                                        <div className={classes.divAlignV2}>
                                            {stepperDetails.status && stepperDetails.status.toLowerCase() == "in_range" &&
                                                <div className={classes.youText} >You<ArrowRightIcon className={classes.arrowRight} /></div>
                                            }
                                            <div>{stepperDetails && stepperDetails.label ? stepperDetails.label : ""}</div>
                                        </div>
                                    </div>
                                </ListItem>
                            ))}
                        </List>
                    </div>

                    <div className={classes.divNoteContainer}>
                        <div className={classes.fwBold}>Note:</div>
                        <div>&nbsp;&nbsp;&nbsp;{cashbackStepperInfo && cashbackStepperInfo.note ? cashbackStepperInfo.note : ""}</div>
                    </div>

                    <div className={classNames(classes.calculatorContainer, classes.mt32)}>
                        <div className={classes.titleV1}>Cashback Calculator</div>
                        <div className={classes.textV1}>What is your monthy fuel expense ?</div>
                        <div className={classNames(classes.divAlignV1, classes.mt8)}>
                            <div className={classNames(classes.width100, classes.mr8)}>
                                <TextField
                                    error={fuelExpenseError}
                                    variant="outlined"
                                    placeholder="Enter Monthly Fuel Expense"
                                    value={numberFormatComma(removeNumberCommas(fuelExpenseValue))}
                                    onChange={(e) => handleFuelExpenseChange(e.target.value)}
                                    className={classes.textFieldV1}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                ₹
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                {fuelExpenseError &&
                                    <FormHelperText error={fuelExpenseError}>Enter valid fuel expense</FormHelperText>
                                }
                            </div>
                            <Button variant="contained" className={confirmDisabled ? classes.disableCalculateButton : classes.calculateButton} onClick={() => handleCalculateClick()}>Calculate</Button>
                        </div>
                        {cashbackCalValue && 'cashbackAmount' in cashbackCalValue &&
                            <div className={classNames(classes.divAmountContainer, classes.divAlign)}>
                                <div className={classes.divAlign}>
                                    <span>Cashback Amount :</span>
                                    <span className={classes.cashbackAmount} >{numberFormat(cashbackCalValue.cashbackAmount)}</span>
                                </div>
                                <div>
                                    {cashbackCalValue.cashbackPercentage}%
                                </div>
                            </div>
                        }
                    </div>
                </SideBarDialogContent>

                <SideBarDialogActions>
                    <Button variant="conatined" className={classes.closeButton} onClick={handleClose}>
                        Close
                    </Button>
                </SideBarDialogActions>

            </Drawer>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchCalculateCashback: (data, onSuccess, onError) => {
        dispatch(calculateCashBack(data, onSuccess, onError))
    },
    dispatchChatView: (value) => dispatch(updateChatView(value)),

});

export default connect(mapStateToProps, mapDispatchToProps)(CashbackStepperDialog);
